
import { Importer, ImportAnalysis, ImportResult, ImportOptions } from '../types';
import { analyzeBackupFile, restoreBackup } from '../../services/backupService';

export const totalGestImporter: Importer = {
    id: 'barberpro-native',
    label: 'Copia de Seguridad BarberPro',
    description: 'Restaura una copia de seguridad nativa (.json o .zip) creada por esta aplicación.',
    accepts: ['.json', '.zip'],

    async canHandle(file: File): Promise<boolean> {
        return true;
    },

    async analyze(file: File): Promise<ImportAnalysis> {
        const result = await analyzeBackupFile(file);
        const summary = result.summary ?? {
            contacts: 0, invoices: 0, quotes: 0, expenses: 0,
            items: 0, templates: 0, recurring: 0, payments: 0,
            inbox: 0, emailTemplates: 0
        };

        return {
            valid: result.valid,
            type: 'BarberPro Backup',
            summary: {
                contacts: summary.contacts,
                invoices: summary.invoices,
                quotes: summary.quotes,
                expenses: summary.expenses,
                items: summary.items,
                templates: summary.templates,
                recurring: summary.recurring,
                payments: summary.payments || 0,
                inbox: summary.inbox || 0,
                emailTemplates: summary.emailTemplates || 0
            },
            warnings: (result as any).warnings || [],
            data: result.data
        };
    },

    async import(file: File, data: any, options?: ImportOptions): Promise<ImportResult> {
        try {
            const clearExisting = options?.clearExisting ?? false;
            const stats = await restoreBackup(data, clearExisting);

            return {
                success: true,
                message: 'Restauración completada correctamente.',
                created: stats.created,
                updated: stats.updated,
                skipped: {},
                errors: [],
                warnings: []
            };
        } catch (e) {
            return { success: false, message: (e as Error).message, errors: [(e as Error).message] };
        }
    }
};
